import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Flex } from '@components/Flex';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { VideoModal } from '@sections/rachel-zoe/components/VideoModal';
import { useManagedSearchParam } from '@hooks/useManagedSearchParam';
import {
  ButtonsContainer,
  HeroTextPairing,
  HeroVideoContainer,
  VideoOverlay,
  HeroTextColumns,
  HeroTextColumn,
  StyledSection,
  StyledButton,
  PlayIcon,
} from '@sections/rachel-zoe/HeroSection/HeroSection.styles';
import { VimeoVideo } from '@components/VimeoVideo';

const rachelZoeData = rachelZoePageData.sections.hero;

export const VIDEO_FEATURE_FLAG = `watchTheFilm`;

export const HeroSection: React.FC = () => {
  const [watchTheFilm, updateWatchTheFilm] = useManagedSearchParam(VIDEO_FEATURE_FLAG);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const posterImage = useMemo(() => cloudAssetUrl('rachel zoe/hero/hero-v2.jpg', { optimization: 'aggressive' }), []);

  const handleWatchVideo = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    updateWatchTheFilm([]);
    setIsModalOpen(false);
  }, [updateWatchTheFilm]);

  useEffect(() => setIsModalOpen((watchTheFilm || []).length > 0), [watchTheFilm]);

  return (
    <StyledSection as="section" id="Rachel_Zoe_Hero" backgroundColor="warmGray1">
      <HeroVideoContainer>
        <VideoOverlay />
        <VimeoVideo
          posterUrl={'rachel zoe/hero/hero-v2.jpg'}
          embedUrl={rachelZoeData.backgroundVideoUrl}
          title="RZ Announcement"
          autoPlay
          background
          controls={false}
          autoPause={false}
          muted
          loop
          cover
          posterOptimization="aggressive"
        />
      </HeroVideoContainer>
      <HeroTextColumns verticalAlign="center">
        <HeroTextColumn width={12}>
          <Flex
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent="flex-end"
            paddingBottom={[8, 10]}
            style={{ minHeight: '100%' }}
          >
            <HeroTextPairing
              title={rachelZoeData.title}
              titleVariant="hed96Break"
              titleColor="mono6"
              titleTagName="h1"
              body={rachelZoeData.content}
              bodyVariant="dek24"
              bodyColor="white"
              bodyTagName="h2"
              bodyMaxWidth="690px"
              marginTop={0}
              marginBottom={6}
              alignment={'center'}
            />
            <ButtonsContainer>
              <StyledButton id="heroSectionWatchTheVideo" variant="darkfindACoupleBtn" onClick={handleWatchVideo}>
                <PlayIcon size={16} name="play" color="white" />
                {rachelZoeData.watchTheVideoBtn}
              </StyledButton>
              <VideoModal videoUrl={rachelZoeData.videoUrl} poster={posterImage} isModalOpen={isModalOpen} handleClose={handleModalClose} />
            </ButtonsContainer>
          </Flex>
        </HeroTextColumn>
      </HeroTextColumns>
    </StyledSection>
  );
};
